const mutations = {
  // 更新 直播状态
   updateLiveStatusState (state, status) {
    state.liveStatus = status
  },

  // 更新 直播状态的信息
  updateLiveStatusReasonState (state, reason) {
    state.liveStatusReason = reason 
  },

  // 更新 当前 AgoraRTCClient 对象
  updateClientState (state, client) {
    state.client = client
  },

  // 更新 直播 token
  updateTokenState (state, token) {
    state.token = token
  },

  // 更新 音频轨道
  updateLocalAudioTrack (state, track) {
    state.localAudioTrack = track
  },

  // 更新 视频轨道
  updateLocalVideoTrack (state, track) {
    state.localVideoTrack = track
  },

  // 更新 rtc 数据
  updateRtcState (state, value) {
    state.rtc = value
  },
 
  // 更新 options 数据
  updateOptionsState (state, value) {
    state.options = value
  },

  // 统一更换数据的方法
  updateLiveState (state, {type, value}) {
    state[type] = value;
  },
  // 更新直播详情
  setLiveDetailData(state, data={}) {
    state.liveDetailData = JSON.parse(JSON.stringify(data));
  },
  // 更新直播详情职位
  setLiveDetailJobList (state, data=[]) {
    state.liveDetailJobList = JSON.parse(JSON.stringify(data));
  },
  // 更新直播详情职位
  setLiveDelivryList (state, data=[]) {
    state.liveDelivryList = JSON.parse(JSON.stringify(data));
  },  
  // 更新直播详情精选提问
  setLiveDetailCommentData (state, data=[]) {
    state.liveDetailCommentData = JSON.parse(JSON.stringify(data));
  },
  // 添加直播详情精选提问
  addLiveDetailComment (state, data) {
    state.liveDetailCommentData = {
      page_count: state.liveDetailCommentData.page_count,
      total_count: state.liveDetailCommentData.total_count + 1,
      comments: [data, ...state.liveDetailCommentData.comments]
    };
  },
  // 删除直播详情精选提问
  removeLiveDetailComment (state, id) {
    let comments = state.liveDetailCommentData.comments.filter(item => item.answer.id !== id)
    state.liveDetailCommentData = {
      page_count: state.liveDetailCommentData.page_count,
      total_count: state.liveDetailCommentData.total_count - 1,
      comments: comments
    };
  },

  // 更新 直播列表职位弹窗数据
  updateJobTabCardDialogData (state, data) {
    state.showJobTabCardDialogData = data
  }
  
  
}

export default mutations
